<p-toast position="top-right"></p-toast>

<!-- Page Header -->
<div class="page-header">
  <!-- Linha 1: navegacao de retorno (para a listagem-pai). Serve tanto de
       breadcrumb ("onde estou / para onde volto") quanto de acao "Voltar". -->
  <button type="button"
    class="btn-voltar"
    [attr.aria-label]="botoes.voltar"
    (click)="voltar()">
    <i class="pi pi-arrow-left"></i>
    <span>{{ breadcrumbRaiz }}</span>
  </button>

  <!-- Linha 2: identidade (avatar + titulo + subtitulo) -->
  <div class="page-header-identity">
    <div class="page-header-icon">
      <i class="pi pi-user"></i>
    </div>
    <div class="page-header-text">
      <h1>{{ tituloHeader }}</h1>
      <p>{{ texts.subtitulo_titulos_pessoa }}</p>
    </div>
  </div>
</div>

<!-- Table Card -->
<div class="table-card">
  <div class="card-header">
    <div class="card-header-icon table-icon">
      <i class="pi pi-file-edit"></i>
    </div>
    <span class="card-header-title">{{ labels.numero_titulo }}</span>

    <!-- Filtro de periodo interativo (recorte por vencimento no backend).
         [persistir]="false": estado local desta tela, sem vazar para a pai. -->
    <div class="card-header-filtro">
      <app-periodo-filtro
        modo="avancado"
        [valorPadrao]="periodoTipoHerdado || 'showAll'"
        [persistir]="false"
        styleClass="w-full"
        (periodoChanged)="onPeriodoChange($event)">
      </app-periodo-filtro>
    </div>
  </div>

  <div class="card-content">
    <p-table
      [value]="titulos"
      [loading]="loading"
      [responsive]="true"
      [breakpoint]="'960px'"
      [scrollable]="true"
      scrollDirection="horizontal"
      [customSort]="true"
      (onSort)="onSortChanged($event)"
      [(selection)]="titulosSelecionados"
      dataKey="id"
      >

      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3rem;">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th pSortableColumn="codigoTitulo">{{ labels.numero_titulo }} <p-sortIcon field="codigoTitulo"></p-sortIcon></th>
          <th pSortableColumn="vencimento">{{ labels.vencimento }} <p-sortIcon field="vencimento"></p-sortIcon></th>
          <th>{{ labels.mes_referencia }}</th>
          <th class="text-center">{{ labels.status }}</th>
          <th>{{ labelRegistro }}</th>
          <th class="text-right">{{ labelPagoRecebido }}</th>
          <th class="text-right">{{ labels.devolvido }}</th>
          <th class="text-right" pSortableColumn="saldo">{{ labels.saldo }} <p-sortIcon field="saldo"></p-sortIcon></th>
          <th class="text-right" pSortableColumn="valor">{{ labels.valor_total }} <p-sortIcon field="valor"></p-sortIcon></th>
          <th class="text-center" style="width: 120px;">{{ labels.acoes }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-titulo>
        <tr [class.linha-destacada]="tituloDestacadoId !== null && titulo.id === tituloDestacadoId">
          <!-- 0. Checkbox (desabilitado para titulos de parcela de contrato:
               nao podem entrar no recebimento em lote — so recebiveis ao faturar). -->
          <td style="width: 3rem;">
            <p-tableCheckbox [value]="titulo" [disabled]="isRecebimentoBloqueadoPorContrato(titulo)"></p-tableCheckbox>
          </td>

          <!-- 1. N Titulo -->
          <td>
            <span class="titulo-numero">#{{ titulo.codigoTitulo || titulo.numeroParcela || titulo.id }}</span>
          </td>

          <!-- 3. Vencimento -->
          <td>
            <span class="vencimento-cell">
              <i class="pi pi-calendar"></i>
              {{ formatarVencimento(titulo.vencimento) }}
            </span>
          </td>

          <!-- 3b. Mês de referência (competência) -->
          <td>
            <span class="mes-referencia-cell">{{ formatarMesReferencia(titulo.dataReferencia) }}</span>
          </td>

          <!-- 4. Status -->
          <td class="text-center">
            <span class="badge badge-aberto" *ngIf="isAberto(titulo)">{{ labels.aberto }}</span>
            <span class="badge badge-pago" *ngIf="isPago(titulo)">{{ labels.pago_status }}</span>
            <span class="badge badge-devolvido" *ngIf="hasDevolvido(titulo)">{{ labels.devolvido }}</span>
            <span class="badge badge-cancelado" *ngIf="isCancelado(titulo)">{{ labels.cancelado }}</span>
          </td>

          <!-- 5. Registro de Pagos/Recebidos -->
          <td>
            <div class="pagamento-registro" *ngIf="titulo.tipoDeCobranca && titulo.tipoDeCobranca.length > 0; else semRegistro">
              <div class="registro-linha" *ngFor="let pag of titulo.tipoDeCobranca">
                <span class="registro-data">{{ formatarVencimento(pag.emissaoMovimento || '') }}</span>
                <span class="registro-valor">{{ formatarValor((pag.valorMovimento || pag.valor), titulo.moeda) }}</span>
              </div>
            </div>
            <ng-template #semRegistro>
              <span class="texto-vazio">-</span>
            </ng-template>
          </td>

          <!-- 6. Pago/Recebido -->
          <td class="text-right">
            <span class="valor-verde">{{ formatarValor(calcularTotalPago(titulo), titulo.moeda) }}</span>
          </td>

          <!-- 7. Devolvido -->
          <td class="text-right">
            <span class="valor-vermelho">{{ formatarValor((titulo.valorDevolvido || 0), titulo.moeda) }}</span>
          </td>

          <!-- 8. Saldo -->
          <td class="text-right">
            <span class="valor-amarelo">{{ formatarValor(titulo.saldo, titulo.moeda) }}</span>
          </td>

          <!-- 9. Valor Total -->
          <td class="text-right">
            <span class="valor-total-cell">{{ formatarValor(titulo.valor, titulo.moeda) }}</span>
          </td>

          <!-- 10. Acoes -->
          <td class="text-center">
            <div class="acoes-cell">
              <!-- Ver fatura de origem: so quando o titulo veio de uma nota/fatura -->
              <button pButton
                type="button"
                *ngIf="temOrigemNota(titulo)"
                class="p-button-sm p-button-text btn-origem"
                icon="pi pi-receipt"
                [pTooltip]="tooltips.ver_fatura"
                tooltipPosition="top"
                [attr.aria-label]="tooltips.ver_fatura"
                (click)="irParaFatura(titulo)">
              </button>

              <!-- Ver despesa acessoria de origem (contador) -->
              <button pButton
                type="button"
                *ngIf="temOrigemDespesaContador(titulo)"
                class="p-button-sm p-button-text btn-origem"
                icon="pi pi-money-bill"
                [pTooltip]="tooltips.ver_despesa"
                tooltipPosition="top"
                [attr.aria-label]="tooltips.ver_despesa"
                (click)="irParaDespesaContador(titulo)">
              </button>

              <!-- Ver contrato do contador de origem -->
              <button pButton
                type="button"
                *ngIf="temOrigemContratoContador(titulo)"
                class="p-button-sm p-button-text btn-origem"
                icon="pi pi-briefcase"
                [pTooltip]="tooltips.ver_contrato"
                tooltipPosition="top"
                [attr.aria-label]="tooltips.ver_contrato"
                (click)="irParaContratoContador(titulo)">
              </button>

              <!-- Cobrar/Pagar (botao-icone com tooltip).
                   O tooltip fica no <span> (nao no <button>) porque um
                   <button disabled> nao emite eventos de mouse — assim o tooltip
                   explicativo aparece mesmo com o botao desabilitado. O botao e
                   desabilitado quando o titulo vem de uma parcela de contrato
                   (so recebivel ao faturar a parcela). -->
              <span *ngIf="isAberto(titulo)"
                class="acao-wrapper"
                [pTooltip]="tooltipBotaoAcao(titulo)"
                tooltipPosition="top">
                <button pButton
                  type="button"
                  [class]="tipoOperacao === 'ENTRADA' ? 'p-button-sm btn-acao btn-acao-entrada' : 'p-button-sm btn-acao btn-acao-saida'"
                  [icon]="tipoOperacao === 'ENTRADA' ? 'pi pi-check' : 'pi pi-wallet'"
                  [disabled]="isRecebimentoBloqueadoPorContrato(titulo)"
                  [attr.aria-label]="tooltipBotaoAcao(titulo)"
                  (click)="abrirDialogRecebimento(titulo)">
                </button>
              </span>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="11" class="empty-message-container">
            <div class="empty-state">
              <i class="pi pi-inbox empty-state-icon"></i>
              <ng-container *ngIf="hasFiltroAtivo; else vazioNeutro">
                <p>{{ mensagens.nenhum_titulo_filtro }}</p>
                <p class="empty-state-dica">{{ mensagens.nenhum_titulo_filtro_dica }}</p>
                <button pButton
                  type="button"
                  class="p-button-text p-button-sm btn-limpar-filtros"
                  icon="pi pi-filter-slash"
                  [label]="labels.limpar_filtros"
                  (click)="limparFiltros()">
                </button>
              </ng-container>
              <ng-template #vazioNeutro>
                <p>{{ mensagens.nenhum_titulo }}</p>
              </ng-template>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!-- Paginacao (mesmo padrao da listagem-pai) -->
    <div class="pagination-container" *ngIf="totalRecords > 0">
      <div>
        <p-paginator
          [rows]="rows"
          [totalRecords]="totalRecords"
          [first]="first"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="{first} - {last} de {totalRecords}"
          [showFirstLastIcon]="true"
          (onPageChange)="onPageChange($event)">
        </p-paginator>
      </div>
      <div class="flex align-items-center">
        <span class="mx-1 text-color">{{ labels.itens_por_pagina }}</span>
        <p-dropdown [options]="pageSizeOptions" optionLabel="label"
          optionValue="value" [(ngModel)]="rows"
          (ngModelChange)="onRowsPerPageChange()" styleClass="w-6rem">
        </p-dropdown>
      </div>
    </div>
  </div>
</div>

<!-- Batch Footer -->
<div class="batch-footer" *ngIf="titulosSelecionados.length > 0">
  <div class="batch-info">
    <span class="batch-count">{{ labelSelecionados }}</span>
    <span class="batch-total">{{ labels.total }}: {{ formatarValor(totalSelecionado, titulosSelecionados[0].moeda) }}</span>
  </div>
  <button pButton
    [label]="botaoAcaoVarios"
    icon="pi pi-check-circle"
    class="btn-receber-varios"
    [loading]="processandoBatch"
    (click)="receberVarios()">
  </button>
</div>

<!-- Dialog intermediario de valor -->
<p-dialog
  [(visible)]="dialogValorVisible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [showHeader]="false"
  styleClass="dialog-wave-redesign dialog-valor"
  [style]="{ width: '420px' }">

  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-wallet" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ labelValorDialog }}</h2>
        <p>{{ labels.saldo_titulo }}: {{ formatarValor(valorMaximo, moedaTitulo) }}</p>
      </div>
    </div>
    <svg class="dialog-wave-svg" viewBox="0 0 500 40" preserveAspectRatio="none">
      <path d="M0,20 Q125,40 250,20 Q375,0 500,20 L500,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-valor-body">
    <div class="field">
      <label>{{ labelValorDialog }}</label>
      <p-inputNumber
        [(ngModel)]="valorDigitado"
        [min]="1"
        [max]="valorMaximo"
        [minFractionDigits]="moedaSemDecimais ? 0 : 2"
        [maxFractionDigits]="moedaSemDecimais ? 0 : 2"
        [showButtons]="false"
        inputStyleClass="valor-input"
        styleClass="valor-input-wrapper"
        mode="decimal"
        locale="pt-BR"
        [useGrouping]="true">
      </p-inputNumber>
    </div>

    <div class="dialog-valor-actions">
      <button pButton
        type="button"
        class="p-button-secondary"
        icon="pi pi-arrow-left"
        [label]="botoes.voltar"
        (click)="cancelarDialogValor()">
      </button>
      <button pButton
        type="button"
        severity="success"
        icon="pi pi-check"
        [label]="labelBotaoConfirmarDialog"
        (click)="confirmarValor()">
      </button>
    </div>
  </div>
</p-dialog>

<!-- Dialog de Forma de Pagamento -->
<!-- moedaNota: spec 07 - propaga moeda do(s) titulo(s) selecionado(s) para
     ativar o filtro `contasFiltradas` (matriz MOEDAS_COMPATIVEIS). Sem isso,
     usuario podia selecionar conta com moeda incompativel e o backend so
     rejeitava no submit (UX confusa). -->
<app-forma-pagamento-dialog
  [(visible)]="dialogVisible"
  [totalAPagar]="totalAPagarDialog"
  [config]="formaPagamentoConfig"
  [moedaNota]="moedaTitulo"
  [contas]="contasFormatadas"
  [processando]="processandoRecebimento || processandoBatch"
  (confirmar)="onConfirmarPagamento($event)"
  (cancelar)="dialogVisible = false">
</app-forma-pagamento-dialog>
